import React from "react";
import styled from "styled-components";
import { Box, Stack } from "@mui/material";
import MemoryIcon from "@mui/icons-material/Memory";

const CustomPaper = styled(Box)`
    border-radius: 14px;
    padding: 28px;
    margin-top: 32px;
    width: 80%;
    border: 1px dashed #636363;
    background-color: none;
`;
const CalculatingCustomModelNotification = () => {
    return (
        <CustomPaper>
            <Stack direction="row" alignItems="center" spacing={2} justifyContent="center">
                <Stack direction="row" alignItems="center" spacing={1}>
                    <Box
                        style={{
                            backgroundColor: "#474747",
                            borderRadius: "46px",
                            height: "46px",
                            width: "46px",
                        }}
                    >
                        <MemoryIcon style={{ margin: "11px" }} />
                    </Box>
                    <p>
                        Your personalised model is being calculated at the moment. You are currently
                        viewing a generic data model. We will notify when the process is finished.
                    </p>
                </Stack>
            </Stack>
        </CustomPaper>
    );
};

export default CalculatingCustomModelNotification;
